module.exports = __webpack_public_path__ + "79f8c557cd3a5857f8b4f0417385ef80.otf";